import { useEffect } from "react";
import { MainLayout } from "@/components/MainLayout";
import { AddExpenseForm } from "@/components/construction/AddExpenseForm";
import { useNavigate } from "react-router-dom";

/**
 * Add Expense Page for Construction
 *
 * OPTIMIZED SHORTCUT: Simplified expense form for construction companies
 *
 * This page provides a streamlined interface for adding expenses to construction
 * works (obras). It features:
 * - Quick category buttons (Material, Labor, Equipment Rental)
 * - Pre-filtered to show only active works (cost centers)
 * - Expense-specific form fields
 *
 * Compared to the general transaction form, this is optimized for:
 * - Speed: Quick category selection
 * - Construction context: Obra-centric language
 * - Simplicity: Only expense-relevant fields
 */
export default function AddExpensePage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Lançar Custo na Obra | Controle Financeiro";
  }, []);

  const handleSuccess = () => {
    // Optionally navigate to dashboard or works list after successful save
    // For now, just keep the form open for multiple entries
  };

  return (
    <MainLayout>
      <div className="container mx-auto py-6 max-w-3xl">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Lançar Custo na Obra</h1>
          <p className="text-muted-foreground">
            Registre rapidamente despesas relacionadas às suas obras
          </p>
        </div>

        <AddExpenseForm onSuccess={handleSuccess} />
      </div>
    </MainLayout>
  );
}
